// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import dayjs from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs';
import antdPlugin from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/antd-dayjs-webpack-plugin/src/antd-plugin.js';

import isSameOrBefore from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/isSameOrBefore';
import isSameOrAfter from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/isSameOrAfter';
import advancedFormat from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/advancedFormat';
import customParseFormat from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/customParseFormat';
import weekday from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/weekday';
import weekYear from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/weekYear';
import weekOfYear from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/weekOfYear';
import isMoment from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/isMoment';
import localeData from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/localeData';
import localizedFormat from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/localizedFormat';
import duration from '/app/online_Blackberry_Web_Operation(后台H5)/node_modules/dayjs/plugin/duration';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(weekYear);
dayjs.extend(weekOfYear);
dayjs.extend(isMoment);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(duration);

dayjs.extend(antdPlugin);
